<script lang="ts">
    export let product: BKDFProduct
    let shownIndex: number = -1
</script>

<section id="ExtendableProductDetails">
    <div
        class="box"
        class:opened="{shownIndex === 0}"
    >
        <div
            class="upper"
            role="button"
            tabindex="0"
            on:keydown
            on:click="{() => {
                if (shownIndex === 0) shownIndex = -1
                else shownIndex = 0
            }}"
        >
            <h4>Beschreibung</h4>
            <div></div>
        </div>
        <div
            class="content"
            class:closed="{shownIndex !== 0}"
        >
            {@html product.descriptionHtml}
        </div>
    </div>
    <div
        class="box"
        class:opened="{shownIndex === 1}"
    >
        <div
            class="upper"
            role="button"
            tabindex="-1"
            on:keydown
            on:click="{() => {
                if (shownIndex === 1) shownIndex = -1
                else shownIndex = 1
            }}"
        >
            <h4>Lieferung & Rücksendung</h4>
            <div></div>
        </div>
        <div
            class="content"
            class:closed="{shownIndex !== 1}"
        >
            <ul>
                <li>
                    <h4>VERSANDKOSTEN - 4,20EUR</h4>
                    <p>Wir versenden innerhalb Deutschlands mit DHL. Die Lieferzeit beträgt 2-3 Werktage.</p>
                </li>
                <li>
                    <h4>RÜCKSENDUNG</h4>
                    <p>
                        Die Rücksendung ist innerhalb von 14 Tagen nach Erhalt der Ware möglich. Die Kosten für die
                        Rücksendung trägt der Käufer.
                    </p>
                </li>
                <li>
                    <h4>MEHR DETAILS</h4>
                    <p>Weitere Informationen zu Versand und Rücksendung findest du in unseren AGBs.</p>
                </li>
            </ul>
        </div>
    </div>
</section>

<style lang="less">
    #ExtendableProductDetails {
        display: flex;
        flex-direction: column;
        margin-bottom: 72px;
        .box {
            border-bottom: 2px solid var(--text-invers-100);
            display: flex;
            transition: padding-bottom 1s;
            padding-bottom: 0px;
            flex-direction: column;
            padding-top: 20px;
            gap: 20px;
            &.opened {
                padding-bottom: 20px;
            }
            .upper {
                cursor: pointer;
                font-size: 1.4rem;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .content {
                max-height: 500px;
                overflow: hidden;
                transition: max-height 1s ease-in;
                ul {
                    padding-left: 20px;
                    list-style-type: disc;
                }

                &.closed {
                    max-height: 0px;
                }
            }
        }
    }
</style>
